import { DataTablePagination, PanelInfo } from '@/components/custom';
import { useUrlParams, useUsers } from '../hooks';
import { Podcast } from 'lucide-react';
import DataTable from './dataTable';
import DataGrid from './DataGrid';

const ViewData = () => {

  const { isLoading, isFetching, data, users } = useUsers();
  const { view } = useUrlParams();

  if (!isLoading && users.length === 0) {
    return (
      <PanelInfo
        title='Aucun utilisateur trouvé'
        description={`Il n'existe pas de compte utilisateur respectant ces critères.`}
        className='py-10 md:py-26 border-none'
        icon={Podcast} />
    );
  }

  return (
    <div className='space-y-5'>
      {
        view === 'row'
          ? <DataTable />
          : <DataGrid />
      }
      {!isFetching && <DataTablePagination pageCount={data?.nbrPages || 0} />}
    </div>
  );

};

export default ViewData;
